<template>
  <div>
    <el-dialog
      title="核销优惠券"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-form
        ref="formRef"
        :model="formData"
        :label-position="'right'"
        size="mini"
        :rules="formRules"
      >
        <el-form-item label="会员信息">
          <el-input v-model="subscriberInfo" disabled></el-input>
        </el-form-item>
        <el-form-item label="优惠券名称">
          <el-input v-model="formData.couponName" disabled></el-input>
        </el-form-item>
        <el-form-item label="优惠券编码">
          <el-input v-model="formData.couponCode" disabled></el-input>
        </el-form-item>
        <el-form-item label="核销事由" prop="reason">
          <el-input
            v-model="formData.reason"
            type="textarea"
            maxlength="255"
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button @click="handleClose">取消</el-button>
        <!-- <el-button type="primary" @click="dataFormSubmit()">确定</el-button> -->
        <el-popconfirm title="确定核销吗?" @onConfirm="dataFormSubmit">
          <el-button type="primary" slot="reference">确定</el-button>
        </el-popconfirm>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { consumeCouponApi } from "@/api/subscriber";
/**
 * 核销优惠券
 */
export default {
  name: "CouponConsume",
  data() {
    return {
      dialogVisible: false,
      formData: {},
      formRules: {
        reason: [{ required: true, message: "请输入核销事由", trigger: "blur" }]
      },
      formLoading: false
    };
  },
  computed: {
    subscriberInfo() {
      const { subscriberName, subscriberPhoneNo } = this.formData || {};
      return `${subscriberName || ""} / ${subscriberPhoneNo || ""}`;
    }
  },
  created() {},
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.formData = {};
    },
    open(info) {
      this.dialogVisible = true;
      this.formData = info;
      this.formLoading = false;
    },
    dataFormSubmit() {
      console.log("this.formData", this.formData);
      this.$refs["formRef"].validate(valid => {
        if (valid) {
          this._saveData();
        }
      });
    },
    _saveData() {
      let _self = this;
      const body = this.formData;
      this.formLoading = true;
      consumeCouponApi(body)
        .then(resp => {
          if (resp.data.status == 100) {
            _self.$message({
              message: resp.data.message,
              type: "success"
            });
            _self.handleClose();
            _self.$emit("refresh");
          } else {
            _self.$message({
              message: resp.data.message,
              type: "error"
            });
          }
        })
        .finally(() => {
          _self.formLoading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// couponConsume.vue?932001e4